import Header from './Header/Header';
import React, { useState } from 'react';
import { parse } from 'date-fns';
import { DATE_FORMAT } from '../constants/RepoReactConstants';
import PropTypes from 'prop-types';

const ExpirationNotification = ({ uInfo, clickCallback }) => {
  const [userInfo] = useState(uInfo);

  const handleAcknowledge = () => {
    clickCallback();
  };

  return (
    <div>
      <br />
      <div className="center">
        <h2>Expiration Information</h2>
      </div>
      <div className="details_cntr">
        <Header heading="" />
        <br />
        <div className="details_cntr">
          <h3>
            Your insurance is due to expire{' '}
            {parse(userInfo.insuranceExpireDate, DATE_FORMAT, new Date()).toLocaleDateString('en-US', {
              month: 'long',
              day: 'numeric',
              year: 'numeric',
            })}{' '}
          </h3>
          <p>
            To avoid an interruption in service and possible cancellation of assignments, please have your insurance
            company e-mail the new certificate to: <a href="mailto:webrepo@ford.com">webrepo@ford.com</a>.
          </p>
        </div>
        <br />
        <br />
        <div className="details_cntr">
          <h3>
            Your repossession license or bond is due to expire{' '}
            {parse(userInfo.buzLcnsExpireDate, DATE_FORMAT, new Date()).toLocaleDateString('en-US', {
              month: 'long',
              day: 'numeric',
              year: 'numeric',
            })}{' '}
          </h3>
          <p>
            To avoid an interruption in service and possible cancellation of assignments, please e-mail the new state
            repossession license to:<a href="mailto:webrepo@ford.com">webrepo@ford.com</a>.
          </p>
        </div>
        <div className="center" style={{ padding: '10px' }}>
          <button type="submit" className="fmc-button" onClick={handleAcknowledge}>
            Acknowledge
          </button>
        </div>
        <div className="fmc-bottom-banner__content center copy-rightbanner">
          Copyright &copy; 2024 Ford Motor Credit Company. All Rights Reserved
        </div>
      </div>
    </div>
  );
};

ExpirationNotification.propTypes = {
  uInfo: PropTypes.object,
  clickCallback: PropTypes.func,
};

export default ExpirationNotification;
